import React from 'react';
import './styles.scss';

const Button = ({ text, type = 'filled', size = 'md' }) => (
  <a className={`Button Button--${type} Button--${size}`}>{text}</a>
);

export default Button;
